import { EventEmitter } from '@ringcentral/rwc-utils/src/event-emitter';

// event constants
export const MEETING_SHUTDOWN = 'meeting-shutdown';
export const LOWERBAR_NQI_HOVER_SUBSCRIBE_KEY = 'lowerbar-nqi-hover';
export const ANNOTATION_EVENTS_RECEIVE = 'annotation-events-receive';
export const ANNOTATION_EVENTS_SEND = 'annotation-events-send';
export const ANNOTATIONS_ENHANCED_STREAM_FAILED = 'annotations-enhanced-stream-failed';
export const RC_EVENTS_RECEIVE = 'rc-events-receive';
export const RC_EVENTS_SEND = 'rc-events-send';
export const SIGN_OUT = 'sign-out';
export const ECHO_RETURN_LOSS_VALUE = 'echo-return-loss-value';
export const SHARING_PLAYBACK_STARTED = 'sharing-playback-started';
export const MEDIA_STREAM_REQUEST = 'media-stream-request';
export const FORCE_DEVICE_ENUM = 'force-device-enum';
export const START_AV_SYNC_SIGNAL = 'start-av-sync-signal';
export const START_LOCAL_STREAM_RECORDING = 'start-local-stream-recording';
export const SET_LIBSFU_INSTANCE = 'set-libsfu-instance';
export const SWITCH_DENOISE_MODE = 'switch_denoise_mode';
export const IS_MAIN_MEDIA_CONNECTED = 'is-main-media-connected';
export const IS_SIGNALING_CONNECTED = 'is-signaling-connected';
export const REQUEST_FULL_RECOVERY = 'request-full-recovery';
/** sent to SSManager when MODAL_SEQUOIA_SS_ALERT is closed, value - doNotShowAgain: boolean */
export const SEQUOIA_SS_ALERT_RESOLVED = `sequoia-ss-alert-resolved`;
export const SIGNAL_MIXED_AUDIO_PROBLEM = 'signal-mixed-audio-problem';
export const VAD_GLITCH_METRIC = 'vad-glitch-metric';
export const SS_FIT_MODE = 'ss-fit-mode';

// Instance of EventEmitter used in different places.
const eventBus = new EventEmitter();
if (typeof window === 'object') {
    window[Symbol.for('rwcEventBus')] = eventBus;
}

export default eventBus;
